module.exports = ".box-document {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  padding: 7px; }\n\n.content-info {\n  height: 50vh; }\n\n.selected-row {\n  background: #bfbfbf8a; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/see-complement/see-complement.component.scss
// module id = ./src/app/pages/see-complement/see-complement.component.scss
// module chunks = main